import Swiper, { Pagination, Navigation } from 'swiper';
Swiper.use([Pagination, Navigation]);

export namespace ProductFunctionsCarousel {
	let setup = () => {
		new Swiper('.js-functions-carousel', {
			loop: false,  // Infinite loop
			slidesPerView: 4,  // Number of slides visible at a time
			spaceBetween: 30,  // Spacing between slides
			navigation: {
				nextEl: '.functions-carousel__inner .swiper-button-next',
				prevEl: '.functions-carousel__inner .swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				// Adjust slides per view depending on the viewport width
				0: {
					slidesPerView: 1,
					spaceBetween: 0,
				},
				900: {
					slidesPerView: 2,
					spaceBetween: 20,
				},
				1300: {
					slidesPerView: 3,
					spaceBetween: 30,
				}
			}
		});
	}

	let carouselFunctions = () => {
		const cards = document.querySelectorAll('.functions-carousel .product-card');

		//when the page loads were getting variantValue;
		cards.forEach((card) => {
			let productImageWrap = card.querySelector('.product-card__img-wrap');
			let productImage = card.querySelector('.product-card__img');
			let productInfo = card.querySelector('.product-card__text-content');
			let swatches = card.querySelectorAll('.functions-carousel__swatch-link');

			swatches.forEach((swatch) => {
				let swatchParent = swatch.parentElement;

				if(swatch.classList.contains('selected')) {
					let pdpUrl = swatch.getAttribute('data-pdp-url');
					productImageWrap.setAttribute('href', pdpUrl);
					productInfo.setAttribute('href', pdpUrl);
					if (window.PriceSpider && typeof window.PriceSpider.rebind === 'function') {
						window.PriceSpider.rebind();
					}
				}

				swatch.addEventListener('click', function (e) {
					e.preventDefault();
					// Update the selected swatch
					swatches.forEach(s => s.parentElement.classList.remove('selected'));
					swatches.forEach(s => s.classList.remove('selected')); // Remove selected class from all swatches
					swatch.classList.add('selected'); // Add selected class to the clicked swatch
					swatchParent.classList.add('selected');

					// Update the product image and URL
					let pdpUrl = swatch.getAttribute('data-pdp-url');
					let productImageUrl = swatch.getAttribute('data-product-image');

					if (pdpUrl) {
						productImageWrap.setAttribute('href', pdpUrl);
						productInfo.setAttribute('href', pdpUrl);
					}
					if (productImageUrl) {
						productImage.setAttribute('src', productImageUrl);
					}

					if (window.PriceSpider && typeof window.PriceSpider.rebind === 'function') {
						window.PriceSpider.rebind();
					}
				});
			});
		});
	}

	export const init = () => {
		setup();
		carouselFunctions();
	}
}


/**
 * DOMContentLoaded may fire before script has a chance to run, so it is wise to check before adding
 */
if (document.readyState === 'loading') {  // Loading hasn't finished yet
	document.addEventListener('DOMContentLoaded', ProductFunctionsCarousel.init);
} else {  // `DOMContentLoaded` has already fired
	ProductFunctionsCarousel.init();
}
